class ReceiveBrachInvoiceCtrl {
    constructor($stateParams) {
        const { invoiceId } = $stateParams
    }
}

ReceiveBrachInvoiceCtrl.$inject = ['$stateParams']
export default ReceiveBrachInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/receiveBranchInvoice/receiveBranchInvoiceCtrl.js